export const PAGE_SIZE = 10;

export enum InsuranceClaimsOrderBy {
  MembershipNo = 'membership_no',
  Status = 'status',
  PatientName = 'patient_name',
  InsurerName = 'insurer_name',
  OutstandingAmount = 'outstanding_amount',
}

export const STATUS_LABEL_MAP: Record<string, string> = {
  submitted: 'Submitted',
  rejected: 'Rejected',
  pending: 'Pending',
  new_claim: 'New claim',
  outstanding: 'Outstanding',
  paid: 'Paid',
};

export const COLUMN_WIDTHS = {
  membershipNumber: 'w-1/5',
  status: 'w-1/6',
  patientName: 'w-1/4',
  insurerName: 'w-1/4',
  amount: 'w-1/6',
} as const;

export const ERROR_MESSAGES = {
  fetchFailed: 'Failed to fetch insurance claims',
} as const;

export const STATUS_OPTIONS = [
  {value: 'new_claim', label: 'New claim', color: 'rgba(71, 84, 103, 1)'},
  {value: 'paid', label: 'Paid', color: '#03820F'},
  {value: 'rejected', label: 'Rejected', color: '#D92D20'},
  {value: 'submitted', label: 'Submitted', color: '#3538CD'},
  {value: 'pending', label: 'Pending', color: '#D29A00'},
  {value: 'outstanding', label: 'Outstanding', color: '#E25300'},
];

export const CLAIM_STATUSES = {
  NEW_CLAIM: 'new_claim',
  PENDING: 'pending',
  SUBMITTED: 'submitted',
  REJECTED: 'rejected',
  PAID: 'paid',
  OUTSTANDING: 'outstanding',
} as const;

export const BILLING_TABLE_COLUMNS = {
  CCSD_CODE: 'CCSD code',
  PROCEDURE_DESCRIPTION: 'Procedure description',
  PROCEDURE_TYPE: 'Procedure type',
  PROCEDURE_PRICE: 'Procedure price',
  NOTES: 'Notes',
} as const;

export const SUMMARY_LABELS = {
  LAST_UPDATE: 'Last update',
  PATIENT_NAME: 'Patient name',
  INSURANCE_PROVIDER: 'Insurance provider',
  MEMBERSHIP_NUMBER: 'Membership number',
  PRE_AUTHORISATION_CODE: 'Pre-authorisation code',
  AMOUNT: 'Amount',
  PAID_AMOUNT: 'Paid amount',
  BILLING: 'Billing',
  GO_TO_PAYMENT: 'Go to payment',
  OUTSTANDING_BALANCE: 'Outstanding balance',
} as const;

export const BUTTON_LABELS = {
  ADD_ITEM: 'Add item',
  FINANCIAL_RECORD: 'Financial record',
  GENERATE_INVOICE: 'Generate invoice',
  BACK: 'Back',
} as const;

export const TOOLTIP_MESSAGES = {
  STATUS_DISABLED: 'Add at least one billing item to change status',
  OUTSTANDING_STATUS_DISABLED: 'Cannot change status once set to Outstanding',
} as const;

export const DEFAULT_VALUES = {
  EMPTY_FIELD: '-',
  CURRENCY_SYMBOL: '£',
  DEFAULT_BILLING_ITEM: {
    id: 0,
    ccsd_code: '',
    description: '',
    category: '',
    item_name: '',
    notes: '',
    amount: 0,
  },
} as const;

export const EDIT_CLAIM_LABELS = {
  TITLE: 'Edit Claim Details',
  INSURANCE_PROVIDER: 'Insurance Provider',
  MEMBERSHIP_NUMBER: 'Membership Number',
  PRE_AUTHORISATION_CODE: 'Pre-Authorisation Code',
  SELECT_INSURANCE_PROVIDER: 'Select insurance provider',
} as const;

export const EDIT_CLAIM_PLACEHOLDERS = {
  MEMBERSHIP_NUMBER: 'Enter membership number',
  PRE_AUTHORISATION_CODE: 'Enter pre-authorisation code',
} as const;

export const EDIT_CLAIM_BUTTONS = {
  SAVE: 'Save',
  CANCEL: 'Cancel',
} as const;

export const EDIT_CLAIM_VALIDATION_MESSAGES = {
  INSURANCE_PROVIDER_REQUIRED: 'Insurance provider is required',
  MEMBERSHIP_NUMBER_REQUIRED: 'Membership number is required',
  PRE_AUTHORISATION_CODE_REQUIRED: 'Pre-authorisation code is required',
} as const;

export const EDIT_CLAIM_DIALOG_CONFIG = {
  WIDTH: '600px',
} as const;

export const VALIDATION_MESSAGES = {
  ONLY_FINANCE_USERS: 'Only finance users can add items',
  ITEMS_NEW_PENDING_ONLY: 'Items can only be added to new or pending claims',
  MEMBERSHIP_NUMBER_REQUIRED: 'Membership number is required',
  INSURER_NAME_REQUIRED: 'Insurer name is required',
  INVOICE_ALREADY_GENERATED: 'Invoice has already been generated',
  ADD_ITEMS_TO_GENERATE: 'Add items to generate invoice',
} as const;

export const INSURANCE_CLAIMS_STRINGS = {
  TITLE: 'Insurance Claims',
  SEARCH_PLACEHOLDER: 'Search claim',
  ALL_CLAIMS: 'All Claims',
  NEW_CLAIM: 'New claim',
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  PAID: 'Paid',
  OUTSTANDING: 'Outstanding',
} as const;
